import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/warnRule";

export default {
    /** 分页查询预警规则 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 保存预警规则 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除预警规则 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 启用/停用预警规则 */
    updateStatus: (id, status) => axios.get({url: `${PREFIX_URI}/updateStatus`, data: {id, status}}),
}
